import React, { Fragment, Component } from 'react';
import map from 'lodash.map';
import filter from 'lodash.filter';
import orderBy from 'lodash.orderby';
import { ProjectTaskListItem } from './ProjectTaskListItem';
import { Loader } from '../../../Loader';
import { Pagination } from '../../../Pagination';
import { ButtonLoader } from '../../../ButtonLoader';
import { Select } from '../../../Select';
import {
	ThematicAreaDropdownOption,
	DistrictDropdownOption,
	BudgetYearDropdownOption,
	ProjectTaskStatusDropdownOption
} from '../../../../utils/enums';
import { PaginationSelect } from '../../../PaginationSelect';

export class ProjectTaskList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			budgetYearId: props.budgetYearId || BudgetYearDropdownOption.NotSetted,
			districtId: props.districtId || DistrictDropdownOption.NotSetted,
			officeThematicAreaId: props.officeThematicAreaId || ThematicAreaDropdownOption.NotSetted,
			status: props.status || ProjectTaskStatusDropdownOption.NotSetted,
			searchTerm: props.searchTerm || '',
			page: 1,
			size: props.size
		};

		this.handleSelect = (fieldName, option) => {
			this.setState({
				[fieldName]: option.value
			});
		};
		this.handleChange = (event) => {
			this.setState({
				searchTerm: event.target.value
			});
		};
		this.handleInvalid = this._handleInvalid.bind(this);
		this.handlePageSizeChanged = this.handlePageSizeChanged.bind(this);

		this.onSearchClick = (e) => {
			e.preventDefault();
			this.props.fetchProjectTasks({
				budgetYearId: this.state.budgetYearId,
				districtId: this.state.districtId,
				officeThematicAreaId: this.state.officeThematicAreaId,
				status: this.state.status,
				searchTerm: this.state.searchTerm,
				page: 1,
				size: this.state.size
			});
		};
	}

	componentDidMount() {
		this.props.fetchProjectTasks({
			budgetYearId: this.state.budgetYearId,
			districtId: this.state.districtId,
			officeThematicAreaId: this.state.officeThematicAreaId,
			status: this.state.status,
			searchTerm: this.state.searchTerm,
			page: this.state.page,
			size: this.state.size
		});
	}

	componentDidUpdate(prevProps) {
		if (prevProps.size !== this.props.size) {
			this.setState({
				size: this.props.size
			});
			this.props.fetchProjectTasks({
				budgetYearId: this.state.budgetYearId,
				districtId: this.state.districtId,
				officeThematicAreaId: this.state.officeThematicAreaId,
				status: this.state.status,
				searchTerm: this.state.searchTerm,
				page: 1,
				size: this.props.size
			});
		}
	}

	renderDistrictOptions() {
		const notSetted = { value: DistrictDropdownOption.NotSetted, text: '[Wszystkie obszary]' };
		const options = map(this.props.districts, (district, i) => ({
			value: district.id,
			text: district.name
		})).sort((a, b) => a.text.localeCompare(b.text, 'pl'));

		return [ notSetted, ...options ];
	}
	renderBudgetYearOptions() {
		const notSetted = { value: BudgetYearDropdownOption.NotSetted, text: '[Wszystkie lata]' };
		const options = orderBy(map(this.props.budgetYears, (budgetYear, i) => ({
			value: budgetYear.id,
			text: budgetYear.year
		})), ['text']);

		return [ notSetted, ...options ];
	}
	renderOfficeThematicAreaOptions() {
		const notSetted = { value: ThematicAreaDropdownOption.NotSetted, text: '[Wszystkie kategorie]' };
		const options = map(
			filter(this.props.officeThematicAreas, { officeId: this.props.defaultOffice.id }),
			(officeThematicArea, i) => ({
				value: officeThematicArea.id,
				text: officeThematicArea.name
			})
		).sort((a, b) => a.text.localeCompare(b.text, 'pl'));

		return [ notSetted, ...options ];
	}

	renderStatusOptions() {
		const notSetted = { value: ProjectTaskStatusDropdownOption.NotSetted, text: '[Wszystkie statusy]' };
		const options = map(filter(this.props.projectTaskStatuses, (o) => o.id > 0), (projectTaskStatus, i) => ({
			value: projectTaskStatus.id,
			text: projectTaskStatus.name
		})).sort((a, b) => a.text.localeCompare(b.text, 'pl'));

		return [ notSetted, ...options ];
	}

	_handleInvalid(e) {
		e.target.setCustomValidity('');
		if (!e.target.validity.valid) {
			if (!e.target.value) {
				e.target.setCustomValidity('Pole jest wymagane');
			} else if (e.target.value.length < 3) {
				e.target.setCustomValidity('Minimalna długość zapytania to 3 znaki');
			}
		}
	}

	handlePageSizeChanged(option) {
		this.props.changePageSize(option.value);
	}

	render() {
		const {
			isProjectTaskListLoading,
			isProjectTaskSearching,
			projectTasks,
			page,
			size,
			totalPages,
			filter,
			nextAction,
			prevAction,
			totalProjectTasks,isOnlyOneOffice
		} = this.props;
		const budgetYearOptions = this.renderBudgetYearOptions();
		const districtOptions = this.renderDistrictOptions();
		const officeThematicAreaOptions = this.renderOfficeThematicAreaOptions();
		const statusOptions = this.renderStatusOptions();

		return (
			<Fragment>
				{isProjectTaskListLoading && <Loader loading={isProjectTaskListLoading} />}
				{!isProjectTaskListLoading && (
					<Fragment>
						<form onSubmit={this.onSearchClick}>
							<div className="row row--justify-end row--space-10 row--top-15 row--bottom-20 project-tasks__header">
								<Select
									options={budgetYearOptions}
									value={this.state.budgetYearId}
									onSelect={(option) => this.handleSelect('budgetYearId', option)}
								/>
								<Select
									options={districtOptions}
									value={this.state.districtId}
									onSelect={(option) => this.handleSelect('districtId', option)}
								/>
								<Select
									options={officeThematicAreaOptions}
									value={this.state.officeThematicAreaId}
									onSelect={(option) => this.handleSelect('officeThematicAreaId', option)}
								/>
								<Select
									options={statusOptions}
									value={this.state.status}
									onSelect={(option) => this.handleSelect('status', option)}
								/>
								<div className="field">
									<input
										className="field__input"
										placeholder="Słowa kluczowe"
										title="Wpisz słowa kluczowe"
										type="text"
										value={this.state.searchTerm}
										onChange={this.handleChange.bind(this)}
										pattern=".{3,}"
										onInvalid={this.handleInvalid}
									/>
								</div>
								{!isProjectTaskSearching && (
									<button
										id="search-button"
										className="button button--primary-dark button--16 button--width-auto"
										type="submit"
										tabIndex="0"
										title="Wyszukaj z zastosowanymi filtrami"
									>
										<span aria-hidden="true">Wyszukaj</span>
									</button>
								)}
								{isProjectTaskSearching && (
									<ButtonLoader
										isExecuting={isProjectTaskSearching}
										executingText="Szukanie"
										color={'#fff'}
									/>
								)}
							</div>
						</form>
						{totalProjectTasks > 0 && (
							<Fragment>
								<div className="project-tasks__list">
									{map(projectTasks, (projectTask, index) => (
										<ProjectTaskListItem key={index} {...projectTask} isOnlyOneOffice={isOnlyOneOffice} />
									))}
								</div>
								<div className="project-tasks__pagination row row--align-center row--justify-space row--top-20">
									<PaginationSelect onPageSizeChanged={this.handlePageSizeChanged} size={size} />
									<Pagination
										currentPage={parseInt(page)}
										totalPages={totalPages}
										nextAction={() =>
											nextAction({
												...filter,
												page: parseInt(page) + 1,
												size: parseInt(size)
											})}
										prevAction={() =>
											prevAction({
												...filter,
												page: parseInt(page) - 1,
												size: parseInt(size)
											})}
									/>
								</div>
							</Fragment>
						)}
						{totalProjectTasks === 0 && (
							<div className="text text--weight-700">Brak projektów spełniających warunek</div>
						)}
					</Fragment>
				)}
			</Fragment>
		);
	}
}
